import * as React from 'react';
import type { LinkFieldsFragment, NavbarDropdownMenuFieldsFragment, ItemsList } from 'types/generated';
import Link from 'next/link';
import NavbarLabel from './NavbarLabel';
import { getOr } from '@/utils/options';
import NavbarDropdownListLabel from './NavbarDropdownListLabel';
import { useSetAtom } from 'jotai';
import { isFullscreenExhaustedAtom } from '@/store';

type Props = {
  data: LinkFieldsFragment | NavbarDropdownMenuFieldsFragment | ItemsList;
  showMobileMenu: boolean;
  isSelected: boolean;
  setOpenDropdownTitle: (title: string | null) => void;
  openDropdownTitle?: string | null;
  transparent?: boolean;
  setOpenList?: (isOpen: boolean) => void;
};

const NavbarLink = ({
  data,
  showMobileMenu,
  isSelected,
  setOpenDropdownTitle,
  openDropdownTitle,
  transparent,
  setOpenList,
}: Props) => {
  const setIsFullscreenExhausted = useSetAtom(isFullscreenExhaustedAtom);
  if (('title' in data && !data.title) || ('uri' in data && !data.uri)) {
    return null;
  }

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (data.__typename === 'NavbarDropdownMenu' && data.title) {
      setOpenDropdownTitle(data.title);
    }
    return;
  };

  switch (data.__typename) {
    case 'Link':
      if (!data.uri) {
        return null;
      }
      return (
        <Link
          href={data.uri}
          className="w-full md:w-auto"
          target={data.title === 'Vefverslun' ? '_blank' : undefined}
          onClick={() => {
            setIsFullscreenExhausted(true);
            document.body.classList.remove('overflow-y-hidden');
            setOpenDropdownTitle(null);
          }}
        >
          <NavbarLabel
            title={getOr(data.title, '')}
            showMobileMenu={showMobileMenu}
            isSelected={isSelected}
            transparent={transparent}
          />
        </Link>
      );
    case 'NavbarDropdownMenu':
      return (
        <NavbarLabel
          onClick={handleClick}
          title={getOr(data.title, '')}
          showMobileMenu={showMobileMenu}
          transparent={transparent}
          isSelected={isSelected}
        />
      );
    case 'ItemsList':
      return (
        <NavbarDropdownListLabel
          setOpenList={setOpenList}
          openDropdownTitle={openDropdownTitle}
          setOpenDropdownTitle={setOpenDropdownTitle}
          title={data.id}
          data={data}
          showMobileMenu={showMobileMenu}
          isSelected={isSelected}
          transparent={transparent}
        />
      );
    default:
      return null;
  }
};

export default NavbarLink;
